export const getFirstRowHeader = (): string[] =>
  [ '', null,
    'TVPI', '', '', '', null,
    'Net IRR', '', '', '', null,
    'MOIC', '', '', '', null,
    'Portfolio IRR', '', '', '', null,
    'Contribution', '', ''];

export const getSecondRowHeaderForDisplay = (): string[] =>
  [ 'Vintage', null,
    'Bottom', 'Median', 'Top', 'Fund', null,
    'Bottom', 'Median', 'Top', 'Fund', null,
    'Bottom', 'Median', 'Top', 'Fund', null,
    'Bottom', 'Median', 'Top', 'Fund', null,
    'Called', 'Unfunded', 'Fund'];

export const getSecondRowHeaderForLogic = (): string[] =>
  [ 'Vintage', 'empty',
    'Bottom0', 'Median0', 'Top0', 'Fund0', 'empty0',
    'Bottom1', 'Median1', 'Top1', 'Fund1', 'empty1',
    'Bottom2', 'Median2', 'Top2', 'Fund2', 'empty2',
    'Bottom3', 'Median3', 'Top3', 'Fund3', 'empty3',
    'Called4', 'Unfunded4', 'Fund4'];
